import { useBlocker } from 'react-router-dom';

interface UseBlockNavigationOptions {
	when: boolean;
	onDiscard?: () => void;
	onSave?: () => void | Promise<void>;
}

interface UseBlockNavigationReturn {
	isBlocking: boolean;
	handleDiscardChanges: () => void;
	handleKeepEditing: () => void;
	handleSaveAndProceed: () => Promise<void>;
}

export const useBlockNavigationOnUnsavedChanges = ({
	when,
	onDiscard,
	onSave,
}: UseBlockNavigationOptions): UseBlockNavigationReturn => {
	const blocker = useBlocker(
		({ currentLocation, nextLocation }) =>
			when && currentLocation.pathname !== nextLocation.pathname,
	);

	const handleDiscardChanges = () => {
		if (onDiscard) {
			onDiscard();
		}
		if (blocker.state === 'blocked') {
			blocker.proceed();
		}
	};

	const handleKeepEditing = () => {
		if (blocker.state === 'blocked') {
			blocker.reset();
		}
	};

	const handleSaveAndProceed = async () => {
		if (onSave) {
			await onSave();
		}

		if (blocker.state === 'blocked') {
			blocker.proceed();
		}
	};

	return {
		isBlocking: blocker.state === 'blocked',
		handleDiscardChanges,
		handleKeepEditing,
		handleSaveAndProceed,
	};
};
